



















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { appConstants } from '@plugin/Common/constants/related-products/app.constants'
import { ProductGridAttributesInterface } from '@plugin/Common/interfaces/related-products/product-grid-attributes.interface'
import { RelatedProductInterface } from '@plugin/Common/interfaces/related-products/related-product.interface'
import RelatedProductCard from '@plugin/Common/components/related-products/RelatedProductCard.vue'

@Component({
  components: { RelatedProductCard },
})
export default class RelatedProductsGridComponent extends Vue {
  @Prop({ default: () => [] })
  products: RelatedProductInterface[]

  @Prop({
    type: String,
    default: '',
  })
  public title: string

  get columnAttributes(): ProductGridAttributesInterface {
    const { productGrid } = appConstants
    const output: ProductGridAttributesInterface = {
      cols: productGrid.columns,
      sm: productGrid.columns / 2,
      md: productGrid.columns / 3,
      lg: productGrid.columns / 4,
    }

    if (productGrid.columnsMobile != productGrid.columns) {
      output.sm = productGrid.columnsMobile
    }

    if (productGrid.columnsTablet != productGrid.columns) {
      output.md = productGrid.columnsTablet
    }

    if (productGrid.columnsDesktop != productGrid.columns) {
      output.lg = productGrid.columnsDesktop
    }

    return output
  }
}
